import React, { useState, useEffect } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { checklistByResourceByProcess } from "../../../graphql/queries";

import {
  Button,
  Grid,
  makeStyles,
  MenuItem,
  TextField,
} from "@material-ui/core";

import {
  FormDataConsumer,
  SelectInput,
  TextInput,
  required,
  BooleanInput,
  useRecordContext,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import { Checklist } from "../../../components/common/Checklist";
import { InboundStepsChoices, processNames } from "../../../utils/constants";
import { logError } from "../../../utils/appUtils";

const useStyles = makeStyles((theme) => ({
  arrayInput: {
    marginTop: theme.spacing(-1),
  },
}));

export const ChecklistForm = (props) => {
  const [checklists, setChecklists] = useState();
  const [selectedChecklist, setSelectedChecklist] = useState();
  const [choices, setChoices] = useState(InboundStepsChoices);
  const form = useForm();
  const classes = useStyles();
  const record = useRecordContext();
  const yardCommodities = window.appUser.reloadYard.activeYardCommodities.items;
  const notify = useNotify();

  useEffect(() => {
    getChecklists();
    if (!record.processName || record.processName === "Inbound Shipment")
      setChoices(InboundStepsChoices);
    else setChoices([]);
  }, []);

  const getChecklists = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(checklistByResourceByProcess, {
          resourceId: window.appUser.reloadYardId,
        })
      );
      const checklists =
        response.data.checklistByResourceByProcess.items.filter(
          (itm) => itm.active
        );
      setChecklists(checklists);
    } catch (err) {
      logError("checklists:ChecklistForm:getChecklists", err, notify);
    }
  };

  const handleProcessChange = (evt) => {
    const value = evt.target.value;
    form.change("checklistItems", [{}]);
    if (value === "Inbound Shipment") setChoices(InboundStepsChoices);
    else setChoices([]);
  };

  const handleChecklistChange = (evt) => {
    setSelectedChecklist(evt.target.value);
  };

  const showCopyChecklist = () => {
    const allowCopy = props.location?.state.allowCopy;
    return allowCopy && checklists?.length > 0;
  };

  const handleCopy = () => {
    debugger;
    const checklist = checklists.find((itm) => itm.id === selectedChecklist);
    form.change("name", checklist.name);
    form.change("processName", checklist.processName);
    form.change("reloadYardCommodityId", checklist.reloadYardCommodityId);
    form.change("checklistItems", checklist.checklistItems);
  };

  return (
    <>
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <Grid container item spacing={2}>
            {showCopyChecklist() && (
              <>
                <Grid item xs={8} md={4}>
                  <TextField
                    id="aisle"
                    label="Yard checklists"
                    variant="outlined"
                    select
                    size="small"
                    disabled={!showCopyChecklist()}
                    required
                    fullWidth
                    value={selectedChecklist || ""}
                    onChange={handleChecklistChange}
                  >
                    {[
                      { id: "", value: "", name: <span>&nbsp;</span> },
                      ...checklists,
                    ].map((itm) => (
                      <MenuItem key={itm.id} value={itm.id}>
                        {itm.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={4} md={8}>
                  <Button
                    variant="outlined"
                    onClick={handleCopy}
                    disabled={!selectedChecklist}
                  >
                    Copy
                  </Button>
                </Grid>
              </>
            )}
            <Grid item xs={12} md={4}>
              <TextInput
                label="Name"
                source="name"
                variant="outlined"
                fullWidth
                validate={required()}
                helperText={false}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <SelectInput
                label="Process Name"
                source="processName"
                variant="outlined"
                fullWidth
                validate={required()}
                choices={processNames}
                helperText={false}
                onChange={handleProcessChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <SelectInput
                source="reloadYardCommodityId"
                label="Load Type"
                variant="outlined"
                fullWidth
                choices={yardCommodities}
                optionText={(choice) =>
                  `${choice.commodity.name} - ${choice.units}`
                }
                optionValue="id"
                helperText={false}
                allowEmpty
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <TextInput
                label="Description"
                source="description"
                variant="outlined"
                multiline
                fullWidth
                helperText={false}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <BooleanInput label="Active" source="active" helperText={false} />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
              <Checklist
                {...props}
                workFlowSteps={choices}
                source="checklistItems"
                label="Checklist Items"
                className={classes.arrayInput}
              />
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </>
  );
};
